import MoleculeRating from '@s-ui/react-molecule-rating'
import {SIZES as MoleculeRatingSizes} from '@s-ui/react-molecule-rating/lib/settings'

import {customStarIcons} from '../config.js'
import {QuestionRenderer} from './QuestionRenderer.js'

export class ScaleQuestionRenderer extends QuestionRenderer {
  render({rating, onRatingChange}) {
    return (
      <MoleculeRating
        initialRating={rating}
        isHovered
        ratingValues={[1, 2, 3, 4, 5]}
        onClick={(e, {value}) => onRatingChange(value)}
        size={MoleculeRatingSizes.LARGE}
        {...customStarIcons}
      />
    )
  }
}
